<h1 mat-dialog-title style="text-align: center; font-size: 1.5rem; color: #3f51b5;">{{ getDialogTitle() | translate }}</h1>

<div [formGroup]="categoryForm" style="padding: 1.5rem; background-color: #f5f5f5; border-radius: 8px; box-shadow: 0px 4px 8px rgba(0,0,0,0.1);">

  <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 1rem;">
    <mat-label>Main Category Name</mat-label>
    <input formControlName="name" matInput placeholder="Enter main category name" />
  </mat-form-field>

  <div formArrayName="subCategories">
    <ng-container *ngFor="let subCategory of subCategories.controls; let i = index">
      <div [formGroupName]="i" style="margin: 1rem 0; padding: 1rem; background-color: #ffffff; border-radius: 8px; box-shadow: 0px 2px 4px rgba(0,0,0,0.1); position: relative;">

        <mat-form-field appearance="outline" style="width: calc(100% - 50px); margin-right: 0.5rem;">
          <mat-label>Subcategory Name</mat-label>
          <input formControlName="name" matInput placeholder="Enter subcategory name" />
        </mat-form-field>

        <button mat-icon-button color="warn" (click)="removeSubCategory(subCategories, i)" style="position: absolute; top: 10px; right: 10px;">
          <mat-icon>close</mat-icon>
        </button>

        <div formArrayName="subCategories" style="margin-top: 1rem;">
          <ng-container *ngFor="let nestedSub of asFormArray(subCategory.get('subCategories')).controls; let j = index">
            <div [formGroupName]="j" style="margin-top: 0.5rem; padding: 0.5rem 1rem; background-color: #f9f9f9; border-radius: 6px; position: relative;">

              <div style="display: flex; gap: 2rem;">
                <mat-form-field appearance="outline" style="width: calc(100% - 50px);">
                  <mat-label>Nested Subcategory Name</mat-label>
                  <input formControlName="name" matInput placeholder="Enter nested subcategory name" />
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: calc(100% - 50px);">
                  <mat-label>Sort Order</mat-label>
                  <input formControlName="sortOrder" matInput placeholder="Enter sort order" />
                </mat-form-field>
              </div>


              <button mat-icon-button color="warn" (click)="removeSubCategory(asFormArray(subCategory.get('subCategories')), j)" style="position: absolute; top: 5px; right: 5px;">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </ng-container>

          <button mat-button color="primary" (click)="addSubCategory(asFormArray(subCategory.get('subCategories')))" style="margin-top: 0.5rem;">
            Add Nested Subcategory
          </button>
        </div>
      </div>
    </ng-container>

    <button mat-button color="primary" (click)="addSubCategory()" style="margin-top: 1rem;">
      Add Subcategory
    </button>
  </div>

  <div style="margin-top: 1.5rem; text-align: right;">
    <button mat-button color="primary" (click)="onSortOrder()" style="margin-right: 0.5rem;">Perditëso Renditjen</button>
    <button mat-button color="primary" (click)="onSave()" style="margin-right: 0.5rem;">Save</button>
    <button mat-button color="warn" (click)="onCancel()">Cancel</button>
  </div>
</div>
